module.exports = {"TXTWCL_Mobile_Number_Verification":{"id":"TXTWCL_Mobile_Number_Verification","defaultMessage":"Verifiering av mobilnummer"}}